import React from "react";
import PaypurposeList from "../components/Paypurpose/PaypurposeList";
import { Typography, Box } from "@mui/material";

const PayPurposePage = ({ onMenuSelect }) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        padding: "24px",
        backgroundColor: "#f5f5f5",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {" "}
      <Typography variant="h4" gutterBottom>
        NPF, UAF Details
      </Typography>
      <PaypurposeList onMenuSelect={onMenuSelect} />
    </Box>
  );
};

export default PayPurposePage;
